import { ArrowRight, Loader2 } from "lucide-react";

export const inputCls =
  "w-full border-b border-linen bg-transparent py-3 text-base text-charcoal placeholder:text-ash/60 outline-none transition-colors duration-300 focus:border-clay";

export function Toggle({ checked, onChange, testId }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-testid={testId}
      onClick={() => onChange(!checked)}
      className={`relative h-8 w-14 shrink-0 rounded-full transition-colors duration-300 ${checked ? "bg-clay" : "bg-linen"}`}
    >
      <span className={`absolute top-1 h-6 w-6 rounded-full bg-cream shadow transition-all duration-300 ${checked ? "left-7" : "left-1"}`} />
    </button>
  );
}

export function Field({ label, htmlFor, children }) {
  return (
    <div className="space-y-1.5">
      <label
        htmlFor={htmlFor}
        className="block text-xs font-medium uppercase tracking-[0.2em] text-ash"
      >
        {label}
      </label>
      {children}
    </div>
  );
}

export function SubmitButton({ loading, children, testId }) {
  return (
    <button
      type="submit"
      data-testid={testId}
      disabled={loading}
      className="group inline-flex items-center gap-3 rounded-full bg-clay px-8 py-4 text-xs font-medium uppercase tracking-[0.15em] text-cream transition-colors duration-300 hover:bg-charcoal disabled:cursor-not-allowed disabled:opacity-60"
    >
      {loading ? (
        <>
          Envoi en cours
          <Loader2 className="h-4 w-4 animate-spin" />
        </>
      ) : (
        <>
          {children}
          <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </>
      )}
    </button>
  );
}
